import { Component } from '@nicolas-riciotti/light2'

export default class AuthorsBrowser extends Component {

    attached() {
        this.names  = [...this.querySelectorAll('.authors__name')]
        this.panels = [...this.querySelectorAll('.authors__panel')]

        this.names.forEach(btn => {
            btn.addEventListener('click', () => this.select(btn.dataset.author))
        })
    }

    select(id) {
        this.names.forEach(b => b.classList.toggle('is-active', b.dataset.author === id))
        this.panels.forEach(p => p.classList.toggle('is-active', p.dataset.panel === id))
    }
}

customElements.define('authors-browser', AuthorsBrowser)
